function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  padding: ",
        ";\n  background: #f0faff;\n  border-top: 1px solid #8ed3ff;\n  border-bottom: 1px solid #8ed3ff;\n\n  font-size: 12px;\n  text-transform: uppercase;\n  margin: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: inherit;\n  font-size: 0.8rem;\n  font-style: italic;\n  text-transform: none;\n  display: block;\n  margin: -5px 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React from "react";
import { Typography } from "antd";
import styled from "styled-components";
var Text = Typography.Text;
var _props_$width, _props_$padding, _props_$margin;
var RawHeader = styled.div(_templateObject(), function(props) {
    return (_props_$width = props.$width) !== null && _props_$width !== void 0 ? _props_$width : "100%";
}, function(props) {
    return (_props_$padding = props.$padding) !== null && _props_$padding !== void 0 ? _props_$padding : "10px 60px";
}, function(props) {
    return (_props_$margin = props.$margin) !== null && _props_$margin !== void 0 ? _props_$margin : "30px 0";
});
var Emphasis = styled.div(_templateObject1());
var Header = function(param) {
    var title = param.title, _param_emphasis = param.emphasis, emphasis = _param_emphasis === void 0 ? null : _param_emphasis, _param_padding = param.padding, padding = _param_padding === void 0 ? null : _param_padding, _param_margin = param.margin, margin = _param_margin === void 0 ? null : _param_margin, _param_width = param.width, width = _param_width === void 0 ? null : _param_width;
    return /*#__PURE__*/ React.createElement(RawHeader, {
        $padding: padding,
        $margin: margin,
        $width: width
    }, /*#__PURE__*/ React.createElement(Text, {
        strong: true
    }, title), emphasis && /*#__PURE__*/ React.createElement(Emphasis, null, emphasis));
};
export default Header;
